const getMultiSelectionShiftEncapsulation = (shift, rowIndex, columnIndex, internship) => {
  return { shift, rowIndex, columnIndex, internship }
}

export {
  getMultiSelectionShiftEncapsulation
}
